import { render, staticRenderFns } from "./VinBlacklist.vue?vue&type=template&id=22dd11b8&scoped=true"
import script from "./VinBlacklist.vue?vue&type=script&lang=js"
export * from "./VinBlacklist.vue?vue&type=script&lang=js"
import style0 from "./VinBlacklist.vue?vue&type=style&index=0&id=22dd11b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd11b8",
  null
  
)

export default component.exports